import { useTranslation } from "react-i18next";
import type { OwnerPayoutStatus } from "./types";

interface OwnerPayoutStatusBadgeProps {
  readonly status: OwnerPayoutStatus;
  readonly testId?: string;
}

const STATUS_CLASS: Readonly<Record<OwnerPayoutStatus, string>> = {
  pending: "bg-muted text-muted-foreground",
  processing: "bg-amber-500/10 text-amber-600",
  completed: "bg-emerald-500/10 text-emerald-600",
  failed: "bg-destructive/10 text-destructive",
};

export function OwnerPayoutStatusBadge({ status, testId }: OwnerPayoutStatusBadgeProps) {
  const { t } = useTranslation();
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${STATUS_CLASS[status]}`}
    >
      {t(`finance.ownerPayouts.status.${status}`)}
    </span>
  );
}
